<template>
  <div class="text-center">
    <v-dialog scrollable v-model="dialog" ref="dlgInfo" width="650">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title class="headline">Selamat!</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="2" sm="2" md="2" lg="2" xl="1">
              <div class="v-avatar primary" style="height: 55px; min-width: 55px; width: 55px;">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-bullhorn theme--light white--text" style="font-size: 30px;"></i>
              </div>
            </v-col>
            <v-col cols="10" sm="10" md="10" lg="10" xl="10">
              <div class="text-left mb-0 pb-0 black--text">
                <p>Sekolah Anda terpilih sebagai sasaran <strong>Diklat Teknis Transisi PAUD ke SD</strong> yang menyenangkan.</p>
                <p class="font-weight-bold py-0 my-0" v-for="sekolah in sasarans" :key="sekolah.index">
                  {{ sekolah.nama }}
                  <v-chip :color="sekolah.is_terdaftar_diklat ? 'success' : 'warning'" small outlined>{{ sekolah.is_terdaftar_diklat ? "Terdaftar" : "Belum Registrasi" }}</v-chip>
                </p>
                <p class="pt-4" v-if="sasarans && sasarans.length > 1">Klik tombol bertanda panah untuk mendaftar sekolah Non Satminkal Anda</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black--text" text @click="closeGuide">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//@group Global Feature
export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      config: null,
      loading: false,
      sasarans: []
    };
  },

  methods: {
    //@vuese
    //buka dialog dan ambil data konfigurasi telegram
    // eslint-disable-next-line
    open(val) {
      this.sasarans = [...val];
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    //@vuese
    //tutup dialog
    closeGuide() {
      this.dialog = false;
      this.resolve();
    },
    //@vuese
    //buka link join telegram sesuai konfigurasi
    toJoin() {
      window.open(this.current_instansi && this.current_instansi.url_telegram ? this.current_instansi.url_telegram : this.config.string, "_blank");
      this.dialog = false;
      this.resolve();
    },
    //@vuese
    //ambil data konfigurasi telegram
    loadConfig() {
      this.loading = true;
      return this.$store
        .dispatch("instansi/config", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          var configTelegram = res.filter(r => (r.key = "url_telegram"));
          this.config = configTelegram && configTelegram.length > 0 ? configTelegram[0] : null;
          this.loading = false;
        })
        .catch(e => e);
    }
  }
};
</script>
